import { Pipe, PipeTransform } from '@angular/core';

type TrackByFunction<I> = (index: number, item: I) => any;

interface TrackByItem {
  [key: string]: any;
}

interface TrackByFunctionCache {
  [key: string]: TrackByFunction<TrackByItem>;
}

const cache: TrackByFunctionCache = {};

@Pipe({
  name: 'trackByProperty',
})
export class TrackByPropertyPipe implements PipeTransform {
  public transform(property: string): TrackByFunction<TrackByItem> {
    if (!cache.hasOwnProperty(property)) {
      cache[property] = (index: number, item: TrackByItem): any => item[property];
    }
    return cache[property];
  }
}
